import React from "react";
import { Link } from "react-router-dom";

function Button({
  Text,
  bgColor,
  textColor,
  Links,
  icon,
}) {
  return (
    <div>
      <Link to={Links}>
        <button
          className={`px-6 py-3 rounded-full bg-${bgColor} text-${textColor} shadow-[6px_6px_#4D2C5E] transition duration-300 flex items-center gap-2`}
        >
          {icon}
          <span>{Text}</span>
        </button>
      </Link>
    </div>
  );
}

export default Button;